export default {
  '41b6a55924934f9561d4165c8fd92f24': 'Print log: Jump to Route 1 in the UC situation',
  '847f8d220f682601c17e64136e1cd019': 'Print log: Jump to Route 2 in the UC case',
  '2a5e8edf4cc6c6e8f83c749055ad0380': 'Product details'
};
